// extracted by mini-css-extract-plugin
export default {"cta-btn":"Button_cta-btn__DsCvv","cta-btn--flex":"Button_cta-btn--flex__+tGld","suffix-icon":"Button_suffix-icon__Hd5st","prefix-icon":"Button_prefix-icon__00MsS"};